/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { Modal, Input, Select } from 'antd'

export default class extends React.Component {
  state = {
    phoneTypeIndex: 0,
    preInput: '',
  }
  //输入电话获取用户信息
  handlePhone = (value) => {
    let phoneNumber = value.replace(/\D/g, '')
    const area = this.props.regionList[this.state.phoneTypeIndex] //当前选中的区域
    let phoneSize //当前选中区域的号码长度
    if (area.name == '中国内地') {
      phoneSize = 11
    } else if (area.name == '中国澳门' || area.name == '中国香港') {
      phoneSize = 8
    } else if (area.name == '中国台湾') {
      phoneSize = 10
    }

    this.setState({ preInput: phoneNumber })
    if (value.length === phoneSize) {
      this.props.fetchGetAccount({ account: value })
      sessionStorage.setItem('account', value)
    }
  }

  render() {
    const { visible, record, deployInfo, regionList } = this.props
    const { phoneTypeIndex, preInput } = this.state
    return (
      <div>
        <Modal
          title="添加人员调配"
          visible={visible}
          onOk={() => {
            sessionStorage.setItem('region_id', regionList[phoneTypeIndex].id)
            this.props.handleOk()
          }}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <div style={{ marginTop: '1rem' }}>
            <span className="info-span">电话:</span>
            <Select
              size="large"
              value={phoneTypeIndex}
              style={{ marginLeft: '1rem' }}
              onChange={(phoneTypeIndex) => {
                this.setState({ phoneTypeIndex }, () => {
                  this.handlePhone(preInput)
                })
              }}
            >
              {regionList &&
                regionList.map((v, index) => {
                  return (
                    <Select.Option key={index} value={index}>
                      {v.name}
                    </Select.Option>
                  )
                })}
            </Select>
            <Input
              size="large"
              defaultValue={record.account}
              style={{ width: '50%', marginLeft: '1rem' }}
              placeholder="请输入手机号码,自动获取用户信息"
              onChange={(e) => this.handlePhone(e.target.value)}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span className="info-span">姓名:</span>
            <Input
              size="large"
              defaultValue={record.member_name}
              value={deployInfo.member_name}
              style={{ width: '71%', marginLeft: '1rem' }}
              placeholder="请输入姓名"
              onChange={(e) =>
                sessionStorage.setItem('member_name', e.target.value)
              }
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span className="info-span">昵称:</span>
            <Input
              size="large"
              defaultValue={record.nickname}
              value={deployInfo.nickname}
              style={{ width: '71%', marginLeft: '1rem' }}
              placeholder="请输入昵称"
              onChange={(e) =>
                sessionStorage.setItem('nickname', e.target.value)
              }
            />
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubDeploy/component/modal.js